const configDev={
    URL:process.env.REACT_APP_FORUM_DEV_API_URL,
    USER:process.env.REACT_APP_FORUM_USER,
    PASS:process.env.REACT_APP_FORUM_PASS,
    STATUS:process.env.NODE_ENV
}
const configProd={
    URL:process.env.REACT_APP_FORUM_PROD_API_URL,
    USER:process.env.REACT_APP_FORUM_USER,
    PASS:process.env.REACT_APP_FORUM_PASS,
    STATUS:process.env.NODE_ENV


}
export const {URL,USER,PASS,ROOT_SITE,URL_QUBISA,USER_QUBISA,PASS_QUBISA,REDIRECT_QUBISA,STATUS}=process.env.NODE_ENV==='production'?configProd:configDev